<template>
  <div class="body">
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="finishedText"
      :immediate-check="false"
      @load="loadMore"
    >
      <van-cell
        v-for="hotcomment in hotcomments" :key="hotcomment.id">
        <CommentDetail
          :comment-id="hotcomment.comment"
          :showThread="false"
          :show-actions="false"
          v-on:reply-to="replyTo"
        />
        <van-row>
          <van-col offset="2" span="22">
            <EpisodeCard
              :compact="true"
              :showDescription="false"
              :showRating="false"
              :showPubtime="false"
              :episodeId="hotcomment.comment_object_id"
            />
          </van-col>
        </van-row>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
  import EpisodeCard from './episode-card.vue'
  import Vue from 'vue'
  import { List } from 'vant'
  import { Cell, CellGroup } from 'vant'
  import CommentDetail from './comment-detail.vue'
  Vue.use(List)
  Vue.use(Cell).use(CellGroup)

  export default {
    name: "HotComments",
    components: {
      CommentDetail,
      EpisodeCard
    },
    props: {
      slug: String,
      limit: { // 显示评论的条数，如果为0，则不加限制
        type: Number,
        default: 0
      }
    },
    computed: {
      theSlug () {
        return this.slug || this.$route.params.slug
      }
    },
    data () {
      return {
        // slugData: null,
        show: false,
        loading: false,
        finished: false,
        finishedText: '没有更多了',
        hotcomments: [],
        next: ''
      }
    },
    watch: {
      // slug (value) {
      //   if (value != '') {
      //     this.getComments()
      //   }
      // }
    },
    methods: {
      loadMore () {
        let that = this
        if (that.next) {
          that.loading = true
          let url = that.next.split('/api/')[1] // 截掉前面的域名和 /api/ 部分
          window.console.log("获取下一页的url:")
          window.console.log(url)
          that.$api.normal.load(url).then(res => {
            that.hotcomments = that.hotcomments.concat(res.data.results)
            that.next = res.data.next
            that.loading = false
            if (that.next == null) {
              that.finished = true
            }
          })
        } else {
          if (that.next === null) {
            that.finished = true
          }
        }
      },
      replyTo () {},
      getComments() {
        let that = this
        // let hotcomments
        let params = { slug: that.theSlug }
        that.$api.hotcomment.show(params).then(res => {
          window.console.log("获取到热门评论")
          window.console.log(res)
          that.$emit('gotHotComments', res.data.count)
          // if (that.limit == 0) {
          //   hotcomments = res.data.results
          // } else if (that.limit > 0) {
          //   hotcomments = res.data.results.slice(0, that.limit)
          // } else {
          //   hotcomments = []
          // }
          // that.hotcomments = hotcomments
          that.next = res.data.next
          that.loading = false
          if (res.data.next == null) {
            that.finished = true
          }
          if (that.limit > 0) {
            that.hotcomments = res.data.results.slice(0, that.limit)
          } else {
            that.hotcomments = res.data.results
          }
        })
      }
    },
    mounted () {
      if (this.limit > 0) {
        this.finished = true
        this.finishedText = ''
      }
      this.getComments()
      // this.slugData = this.$route.params.slug
      // window.console.log("SLUG: ")
      // window.console.log(this.$route.params.slug)
      // if (this.theSlug) {
      //   // for (var i = 0; i < count; i++) {
      //   //   this.hotcomments.push({})
      //   // }
      //   this.getComments()
      // }
    },
    activated () {
      window.console.log('About has been activated')
      this.getComments()
    },
    deactivated () {
      window.console.log('About has been deactivated')
    }
  }
</script>

<style lang="css" scoped>
  .body {
    background: #fff;
  }
</style>
